import { render } from "./PlantillaNotificacionCorreo.vue?vue&type=template&id=67eb8dc8"
import script from "./PlantillaNotificacionCorreo.vue?vue&type=script&lang=js"
export * from "./PlantillaNotificacionCorreo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__